import * as ReactDOM from "react-dom/client";
import Router from "./app/router";
import "./styles.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(<Router />);
